module.exports = __webpack_public_path__ + "img/compas-1.ee64df48.svg";